import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["date", "className", "withIcon", "view", "side", "stage"];
import React, { useMemo } from 'react';
import { Text } from '@carnica/ui-kit';
import { format } from 'date-fns';
import { cnBem } from "../../../../shared/lib";
import { MessagePropStage } from "../../types";
import styles from "./styles.pcss";
import { IconCheckMarkDoubleCheck, IconTimeOutline } from "./utils";
var cnDateBlock = cnBem('date-block', styles);
var iconsMap = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, MessagePropStage.PENDING, IconTimeOutline), MessagePropStage.READED, IconTimeOutline), MessagePropStage.SUBMITED, IconCheckMarkDoubleCheck), MessagePropStage.UNKNOWN, null), MessagePropStage.REJECTED, null);
export var DateBlock = function DateBlock(props) {
  var dateProp = props.date,
    className = props.className,
    _props$withIcon = props.withIcon,
    withIcon = _props$withIcon === void 0 ? true : _props$withIcon,
    _props$view = props.view,
    view = _props$view === void 0 ? 'inside' : _props$view,
    _props$side = props.side,
    side = _props$side === void 0 ? 'main' : _props$side,
    _props$stage = props.stage,
    stage = _props$stage === void 0 ? MessagePropStage.UNKNOWN : _props$stage,
    otherProps = _objectWithoutProperties(props, _excluded);
  var Icon = iconsMap[stage];
  var date = useMemo(function () {
    return dateProp ? format(new Date(dateProp), 'HH:mm') : null;
  }, [dateProp]);
  return /*#__PURE__*/React.createElement(Text, _extends({
    align: "right",
    className: cnDateBlock({
      view: view,
      side: side
    }, [className]),
    color: side === 'main' ? 'primary' : 'tertiary',
    tagName: "time",
    variant: "caption-medium"
  }, otherProps, {
    "data-t-id": "ui-DateBlock"
  }), date, withIcon && Icon && /*#__PURE__*/React.createElement(Icon, {
    color: side === 'main' ? 'primary' : 'tertiary',
    size: "xs"
  }));
};